export const AMOUNTS_BUY_DEALER = 'AMOUNTS::AMOUNTS_BUY_DEALER';